enum COLOR {
  Primary = 'primary',
  Default = 'default',
  Warning = 'warning',
  Danger = 'danger',
}
export default COLOR;
